import NotificationType from './NotificationType'

const notificationReducer = (state, action) => {
  switch (action.type) {
    case NotificationType.GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
        loading: false,
      }
    case NotificationType.GET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default notificationReducer
